import { Map, List } from "immutable";
import { FINANCIALS_ACTIONS } from "constants/actions";
import { FinancialYearRecord } from "records";
import { STATE_STATUS } from "constants/state-status";
import { FinancialDetailRecord } from "records/index";
import moment from "moment";

const INITIAL_STATE = new Map({
    financialYearsStatus: STATE_STATUS.UNFETCHED,
    financialYears: new List([]),
    companyId: null,
    list: new Map({})
});

export default (state = INITIAL_STATE, { type, payload }) => {
    switch (type) {
    case FINANCIALS_ACTIONS.CREATE_FINANCIAL_YEAR:
        return state.set("financialYearsStatus", STATE_STATUS.UPDATING);
    case FINANCIALS_ACTIONS.CREATED_FINANCIAL_YEAR:
        return state
            .set("financialYearsStatus", STATE_STATUS.FETCHED)
            .mergeIn(
                ["financialYears"],
                [new FinancialYearRecord(payload.yearRecord)]
            );
    case FINANCIALS_ACTIONS.FAILED_CREATE_FINANCIAL_YEAR:
        return state;
    case FINANCIALS_ACTIONS.FETCH_FINANCIAL_YEARS:
        return state.set("financialYearsStatus", STATE_STATUS.FETCHING);
    case FINANCIALS_ACTIONS.FETCHED_FINANCIAL_YEARS:
        return state.set("financialYearsStatus", STATE_STATUS.FETCHED).set(
            "financialYears",
            new List(payload.financialYearRecords).map(
                _ =>
                    new FinancialYearRecord({
                        ..._,
                        start_date: moment(_.start_date),
                        end_date: moment(_.end_date)
                    })
            )
        );
    case FINANCIALS_ACTIONS.FAILED_FETCH_FINANCIAL_YEARS:
        return state;
    case FINANCIALS_ACTIONS.FETCH_FINANCIALS:
        return state.setIn(
            ["list", payload.companyId],
            new Map({
                status: STATE_STATUS.FETCHING,
                data: new List([])
            })
        );
    case FINANCIALS_ACTIONS.FETCHED_FINANCIALS:
        return state
            .setIn(
                ["list", payload.companyId, "status"],
                STATE_STATUS.FETCHED
            )
            .setIn(
                ["list", payload.companyId, "data"],
                new List(payload.financialRecords).map(
                    _ =>
                        new FinancialDetailRecord(
                            new Map(_).map((v, k) => {
                                if (
                                    ![
                                        "case",
                                        "company",
                                        "created_by",
                                        "modified_by",
                                        "create_date",
                                        "modified_date",
                                        "is_active",
                                        "financial_year"
                                    ].includes(k)
                                ) {
                                    return Number(v);
                                }
                                if (k === "financial_year") {
                                    return new FinancialYearRecord({
                                        ...v,
                                        start_date: moment(v.start_date),
                                        end_date: moment(v.end_date)
                                    });
                                }
                                return v;
                            })
                        )
                )
            );
    case FINANCIALS_ACTIONS.FAILED_FETCH_FINANCIALS:
        return state.setIn(
            ["list", payload.companyId],
            new Map({
                status: STATE_STATUS.FETCH_FAILED,
                data: new List([])
            })
        );
    case FINANCIALS_ACTIONS.UPDATE_FINANCIALS:
        return state
            .setIn(
                ["list", payload.companyId, "status"],
                STATE_STATUS.UPDATING
            )
            .setIn(
                ["list", payload.companyId, "data"],
                new List(payload.financialRecords).map(
                    _ =>
                        new FinancialDetailRecord(
                            new Map(_).map((v, k) => {
                                if (
                                    ![
                                        "case",
                                        "company",
                                        "created_by",
                                        "modified_by",
                                        "create_date",
                                        "modified_date",
                                        "is_active"
                                    ].includes(k)
                                ) {
                                    return Number(v);
                                }
                                if (k === "financial_year") {
                                    return new FinancialYearRecord({
                                        ...v,
                                        start_date: moment(v.start_date),
                                        end_date: moment(v.end_date)
                                    });
                                }
                                return v;
                            })
                        )
                )
            );
    case FINANCIALS_ACTIONS.UPDATED_FINANCIALS:
        return state
            .setIn(
                ["list", payload.companyId, "status"],
                STATE_STATUS.FETCHED
            )
            .setIn(
                ["list", payload.companyId, "data"],
                new List(payload.financialRecords).map(
                    _ =>
                        new FinancialDetailRecord(
                            new Map(_).map((v, k) => {
                                if (
                                    ![
                                        "case",
                                        "company",
                                        "financial_year",
                                        "created_by",
                                        "modified_by",
                                        "create_date",
                                        "modified_date",
                                        "is_active"
                                    ].includes(k)
                                ) {
                                    return Number(v);
                                }
                                return v;
                            })
                        )
                )
            );
    case FINANCIALS_ACTIONS.FAILED_UPDATE_FINANCIALS:
        return state;
    case "LOGOUT":
        return INITIAL_STATE;
    default:
        return state;
    }
};
